import { request } from "@certn/legacy-api";

import constants from "../../../constants";

const accessID = constants.VITE_CLICKWRAP_ACCESS_ID;
const VITE_CLICKWRAP_TOU_AND_PRIVACY_POLICY_GROUP_KEY = "group-rkcrhcnqs";
const isTestMode = constants.MODE !== "production";

export async function fetchContracts(): Promise<{
  group: number;
  contract_data: { [key: string]: { title: string; download_url: string } };
  contracts: number[];
  versions: string[];
}> {
  const response = await request<{
    group: number;
    contract_data: { [key: string]: { title: string; download_url: string } };
    contracts: number[];
    versions: string[];
  }>(
    `https://pactsafe.io/load/json?sid=${accessID}&gkey=${VITE_CLICKWRAP_TOU_AND_PRIVACY_POLICY_GROUP_KEY}`,
    {
      method: "GET",
    }
  );
  return response;
}

export async function signContracts({
  signerID,
  versionID,
  groupID,
}: {
  signerID: string;
  versionID: string;
  groupID: string;
}) {
  const url = `https://pactsafe.io/send?sid=${accessID}&sig=${signerID}&vid=${versionID}&gid=${groupID}&tm=${isTestMode}`;
  await fetch(url, {
    method: "POST",
  });
}

export const fakeContractData = {
  group: 37684,
  contract_data: {
    "220593": {
      title: "Random Title 1",
      download_url:
        "https://api.pactsafe.com/v1.1/download/contracts/220593/rendered/64caa507faf3524b1c5c95be",
    },
    "220594": {
      title: "Random Title 2",
      download_url:
        "https://api.pactsafe.com/v1.1/download/contracts/220594/rendered/64caa507faf3524b1c5c95be",
    },
  },
  contracts: [220593, 220594],
  versions: ["642de464dcb7be2d1e82ecac", "643ee739376ada6a64d95e7b"],
};
